import {MobileMenu} from './nav/mobileMenu';

new MobileMenu();
